var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer_service_wrap" },
    [
      _c(
        "div",
        {
          staticClass: "service_btn",
          class: { has_unread: _vm.totalUnread > 0 },
          on: { click: _vm.toggleChat }
        },
        [
          _c("i", { staticClass: "el-icon-headset" }),
          _vm._v(" "),
          _vm.totalUnread > 0
            ? _c("span", { staticClass: "unread_dot" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.totalUnread > 99 ? "99+" : _vm.totalUnread) +
                    "\n    "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "chat-slide" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showChat,
                expression: "showChat"
              }
            ],
            ref: "chatBox",
            staticClass: "chat_box",
            style: _vm.chatBoxStyle
          },
          [
            _c("div", { staticClass: "nav_bar" }, [
              _c(
                "div",
                {
                  staticClass: "nav_item",
                  class: { active: _vm.activeTab === "chat" },
                  attrs: { title: "最近聊天" },
                  on: {
                    click: function($event) {
                      return _vm.switchTab("chat")
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-chat-dot-round" }),
                  _vm._v(" "),
                  _vm.totalUnread > 0
                    ? _c("span", { staticClass: "nav_badge" }, [
                        _vm._v(
                          _vm._s(_vm.totalUnread > 99 ? "99+" : _vm.totalUnread)
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nav_item",
                  class: { active: _vm.activeTab === "contacts" },
                  attrs: { title: "成员列表" },
                  on: {
                    click: function($event) {
                      return _vm.switchTab("contacts")
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-user" })]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nav_item",
                  class: { active: _vm.activeTab === "files" },
                  attrs: { title: "文件记录" },
                  on: {
                    click: function($event) {
                      return _vm.switchTab("files")
                    }
                  }
                },
                [_c("i", { staticClass: "el-icon-folder-opened" })]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat_sidebar" },
              [
                _vm.activeTab === "chat"
                  ? [
                      _c("div", { staticClass: "sidebar_header" }, [
                        _c("span", { staticClass: "sidebar_title" }, [
                          _vm._v("最近聊天")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "conversation_list" },
                        [
                          _vm._l(_vm.recentChatList, function(room) {
                            return _c(
                              "div",
                              {
                                key: room.id,
                                staticClass: "conversation_item",
                                class: {
                                  active:
                                    _vm.currentRoom &&
                                    _vm.currentRoom.id === room.id
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.selectRoom(room)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "conv_avatar",
                                    class: { group_avatar: room.roomType === 2 }
                                  },
                                  [
                                    room.roomType === 2
                                      ? [
                                          _c("i", {
                                            staticClass: "el-icon-user"
                                          })
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            { staticClass: "avatar_text" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  room.roomName
                                                    ? room.roomName.charAt(0)
                                                    : "?"
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                    _vm._v(" "),
                                    room.unReadNum > 0
                                      ? _c(
                                          "span",
                                          { staticClass: "conv_unread" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  room.unReadNum > 99
                                                    ? "99+"
                                                    : room.unReadNum
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "conv_info" }, [
                                  _c("div", { staticClass: "conv_top" }, [
                                    _c("span", { staticClass: "conv_name" }, [
                                      _vm._v(_vm._s(room.roomName))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "conv_time" }, [
                                      _vm._v(
                                        _vm._s(_vm.formatTime(room.updateTime))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "conv_bottom" }, [
                                    _c("span", { staticClass: "conv_msg" }, [
                                      _vm._v("暂无消息")
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.recentChatList.length === 0
                            ? _c("div", { staticClass: "empty_list" }, [
                                _c("p", [_vm._v("暂无聊天记录")])
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  : _vm.activeTab === "contacts"
                  ? [
                      _c("div", { staticClass: "sidebar_header" }, [
                        _c("span", { staticClass: "sidebar_title" }, [
                          _vm._v("老师列表")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "conversation_list" },
                        [
                          _vm._l(_vm.teacherList, function(teacher) {
                            return _c(
                              "div",
                              {
                                key: teacher.userId,
                                staticClass: "conversation_item",
                                on: {
                                  click: function($event) {
                                    return _vm.selectTeacher(teacher)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "conv_avatar" }, [
                                  teacher.avatar
                                    ? _c("img", {
                                        attrs: { src: teacher.avatar, alt: "" }
                                      })
                                    : _c(
                                        "span",
                                        { staticClass: "avatar_text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              teacher.nickName
                                                ? teacher.nickName.charAt(0)
                                                : "师"
                                            )
                                          )
                                        ]
                                      )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "conv_info" }, [
                                  _c("div", { staticClass: "conv_top" }, [
                                    _c("span", { staticClass: "conv_name" }, [
                                      _vm._v(_vm._s(teacher.nickName))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "conv_bottom" }, [
                                    _c("span", { staticClass: "conv_msg" }, [
                                      _vm._v(_vm._s(teacher.courseName))
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.teacherList.length === 0
                            ? _c("div", { staticClass: "empty_list" }, [
                                _c("p", [_vm._v("暂无老师")])
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ]
                  : _vm.activeTab === "files"
                  ? [
                      _c("div", { staticClass: "sidebar_header" }, [
                        _c("span", { staticClass: "sidebar_title" }, [
                          _vm._v("文件记录")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "file_tabs" }, [
                        _c(
                          "div",
                          {
                            staticClass: "file_tab",
                            class: { active: _vm.fileTab === "images" },
                            on: {
                              click: function($event) {
                                _vm.fileTab = "images"
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("图片")])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "file_tab",
                            class: { active: _vm.fileTab === "files" },
                            on: {
                              click: function($event) {
                                _vm.fileTab = "files"
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "el-icon-document" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("文件")])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "file_list" },
                        [
                          _vm.fileTab === "images"
                            ? [
                                _vm.imageList.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "image_grid" },
                                      _vm._l(_vm.imageList, function(
                                        img,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "image_item"
                                          },
                                          [
                                            _c("el-image", {
                                              attrs: {
                                                src: img.content,
                                                "preview-src-list": _vm.imageList.map(
                                                  function(i) {
                                                    return i.content
                                                  }
                                                ),
                                                fit: "cover"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "image_info" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatFullTime(
                                                      img.timestamp
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _c("div", { staticClass: "empty_list" }, [
                                      _c("p", [_vm._v("暂无图片")])
                                    ])
                              ]
                            : [
                                _vm.fileList.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.fileList, function(
                                        file,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "file_item"
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-document"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "file_info" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "file_name" },
                                                  [_vm._v(_vm._s(file.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "file_date" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatFullTime(
                                                          file.timestamp
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _c("div", { staticClass: "empty_list" }, [
                                      _c("p", [_vm._v("暂无文件")])
                                    ])
                              ]
                        ],
                        2
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chat_main" },
              [
                _vm.activeTab === "files"
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "chat_header drag_handle",
                          on: { mousedown: _vm.startDrag }
                        },
                        [
                          _c("span", { staticClass: "chat_title" }, [
                            _vm._v(
                              _vm._s(_vm.fileTab === "images" ? "图片" : "文件")
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "header_actions",
                              on: {
                                mousedown: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-minus",
                                on: { click: _vm.toggleChat }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: { click: _vm.closeChat }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "files_main_content" }, [
                        _c(
                          "div",
                          { staticClass: "files_display_area" },
                          [
                            _vm.fileTab === "images"
                              ? [
                                  _vm.imageList.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "images_gallery" },
                                        _vm._l(_vm.imageList, function(
                                          img,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "gallery_item"
                                            },
                                            [
                                              _c("el-image", {
                                                attrs: {
                                                  src: img.content,
                                                  "preview-src-list": _vm.imageList.map(
                                                    function(i) {
                                                      return i.content
                                                    }
                                                  ),
                                                  fit: "cover"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "gallery_item_info"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sender" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(img.senderName)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "time" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatFullTime(
                                                            img.timestamp
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "files_empty" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline"
                                          }),
                                          _vm._v(" "),
                                          _c("p", [_vm._v("暂无图片记录")])
                                        ]
                                      )
                                ]
                              : [
                                  _vm.fileList.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "files_list_main" },
                                        _vm._l(_vm.fileList, function(
                                          file,
                                          index
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticClass: "file_list_item"
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-document"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "file_detail" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "file_name"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          file.name || "文件"
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "file_meta"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            file.senderName
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatFullTime(
                                                              file.timestamp
                                                            )
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "files_empty" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-document"
                                          }),
                                          _vm._v(" "),
                                          _c("p", [_vm._v("暂无文件记录")])
                                        ]
                                      )
                                ]
                          ],
                          2
                        )
                      ])
                    ]
                  : _vm.currentRoom
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "chat_header drag_handle",
                          on: { mousedown: _vm.startDrag }
                        },
                        [
                          _c("span", { staticClass: "chat_title" }, [
                            _vm._v(_vm._s(_vm.currentRoom.roomName))
                          ]),
                          _vm._v(" "),
                          _vm.currentRoom.roomType === 2
                            ? _c("span", { staticClass: "member_count" }, [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(_vm.currentRoomMembers.length) +
                                    "人)\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "header_actions",
                              on: {
                                mousedown: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-minus",
                                on: { click: _vm.toggleChat }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: { click: _vm.closeChat }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { ref: "messageList", staticClass: "message_list" },
                        [
                          _vm._l(_vm.currentMessages, function(message, index) {
                            return _c(
                              "div",
                              {
                                key: message.id,
                                staticClass: "message_wrapper"
                              },
                              [
                                _vm.showTimeDivider(message, index)
                                  ? _c("div", { staticClass: "time_divider" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatFullTime(
                                              message.createTime
                                            )
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "message_item",
                                    class: {
                                      message_self:
                                        message.senderId == _vm.currentUserId
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "message_avatar" },
                                      [
                                        message.senderAvatar
                                          ? _c("img", {
                                              attrs: {
                                                src: message.senderAvatar,
                                                alt: ""
                                              }
                                            })
                                          : _c(
                                              "span",
                                              { staticClass: "avatar_text" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    message.senderName
                                                      ? message.senderName.charAt(
                                                          0
                                                        )
                                                      : "?"
                                                  )
                                                )
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "message_body" }, [
                                      _vm.currentRoom.roomType === 2 &&
                                      message.senderId != _vm.currentUserId
                                        ? _c(
                                            "div",
                                            { staticClass: "sender_name" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(message.senderName) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "message_bubble",
                                          class: {
                                            image_bubble: message.msgType === 2,
                                            file_bubble: message.msgType === 3
                                          }
                                        },
                                        [
                                          message.msgType === 1
                                            ? [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "message_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.content)
                                                    )
                                                  ]
                                                )
                                              ]
                                            : message.msgType === 2
                                            ? [
                                                _c("el-image", {
                                                  staticClass: "message_image",
                                                  attrs: {
                                                    src: message.content,
                                                    "preview-src-list": [
                                                      message.content
                                                    ],
                                                    fit: "cover"
                                                  }
                                                })
                                              ]
                                            : message.msgType === 3
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "message_file",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downloadFile(
                                                          message
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-document"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "file_info"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "file_name"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "[文件] " +
                                                                _vm._s(
                                                                  message.content
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "message_text"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(message.content)
                                                    )
                                                  ]
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.currentMessages.length === 0
                            ? _c("div", { staticClass: "empty_message" }, [
                                _c("p", [_vm._v("暂无消息，开始聊天吧")])
                              ])
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_area" }, [
                        _c("div", { staticClass: "input_box" }, [
                          _c(
                            "div",
                            { staticClass: "input_toolbar" },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "imageUpload",
                                  attrs: {
                                    action: "",
                                    "auto-upload": false,
                                    "show-file-list": false,
                                    accept: "image/*",
                                    "on-change": _vm.handleImageSelect
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-picture-outline toolbar_icon",
                                    attrs: { title: "发送图片" }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "input_container" }, [
                            _c("textarea", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.messageInput,
                                  expression: "messageInput"
                                }
                              ],
                              attrs: { placeholder: "请输入消息..." },
                              domProps: { value: _vm.messageInput },
                              on: {
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleEnterKey.apply(
                                    null,
                                    arguments
                                  )
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.messageInput = $event.target.value
                                }
                              }
                            })
                          ])
                        ])
                      ])
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass: "chat_header empty_header drag_handle",
                          on: { mousedown: _vm.startDrag }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "header_actions",
                              on: {
                                mousedown: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-minus",
                                on: { click: _vm.toggleChat }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: { click: _vm.closeChat }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "chat_placeholder" }, [
                        _c("i", { staticClass: "el-icon-chat-dot-round" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("选择一位老师开始咨询")])
                      ])
                    ]
              ],
              2
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-593ae36f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593ae36f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerServiceChat.vue
// module id = null
// module chunks = 